var kind = require("enyo/kind");

require("./SvgIcon.less");

module.exports = kind(/** @lends  app.ui.SvgIcon.prototype */ {

    /**
     * @private
     */
    name: "app.ui.SvgIcon",

    /**
     * @private
     */
    classes: "app-ui-svg-icon",

    /**
     * @private
     */
    tag: "svg",

    /**
     * @private
     */
    attributes: {
        viewbox: "0 0 24 24"
    },

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type {?string}
     * @public
     */
    icon: null,

    /**
     * @private
     */
    components: [{
        name:    "symbol",
        tag:     "use",
        classes: "app-ui-svg-icon__symbol"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.iconChanged();
        };
    }),

    /**
     * @private
     */
    iconChanged: function() {
        this.$.symbol.setAttribute("xlink:href", ("#" + this.icon) || null);
    }

});
